import React, { Component } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class CompleteTransaction extends Component {

    

    render() {

        // var userToken = localStorage.getItem('token');
        // if(! userToken) {
        //       return <Navigate  to='/login' replace="true" />
        //   }

          return (
            <div>

                <div class="docs-content">

                    <div class="container">


                        <article class="docs-article">

                            <h1 class="docs-heading">
                                Complete Transaction Flow Example
                            </h1>


                            <section class="docs-intro">

                                <h2 class="section-heading">
                                    Overview
                                </h2>

                                <p>
                                    The following sequence illustrates the complete
                                    end-to-end remittance transaction flow.
                                </p>

                                <p>
                                    Each step must be executed in sequence, and all
                                    dependent data such as <code>session_id</code>,
                                    <code>locationId</code>, and calculated amounts
                                    must be preserved and reused across APIs.
                                </p>

                            </section>


                        </article>



                        <article class="docs-article">

                            <section class="docs-section">


                                <h2 class="section-heading">
                                    Transaction Flow Steps
                                </h2>


                                <table class="table table-bordered table-white">

                                    <thead>

                                        <tr>
                                            <th>Step</th>
                                            <th>Action</th>
                                            <th>API / Details</th>
                                        </tr>

                                    </thead>


                                    <tbody>


                                        <tr>
                                            <td>Step 1</td>
                                            <td>
                                                Retrieve Supported Countries
                                            </td>
                                            <td>
                                                POST /v2/merchant/get-remittance-countries-list
                                            </td>
                                        </tr>


                                        <tr>
                                            <td>Step 2</td>
                                            <td>
                                                Customer Selects Destination Country
                                            </td>
                                            <td>
                                                Example: IN (India)
                                            </td>
                                        </tr>


                                        <tr>
                                            <td>Step 3</td>
                                            <td>
                                                Retrieve Available Corridors
                                            </td>
                                            <td>
                                                POST /v2/merchant/get-available-corridors
                                                <br />
                                                Output:
                                                <code>session_id</code>
                                                (must be stored for entire transaction flow)
                                            </td>
                                        </tr>


                                        <tr>
                                            <td>Step 4</td>
                                            <td>
                                                Store Session ID
                                            </td>
                                            <td>
                                                Example:
                                                SESS_UWX2OXWDPURTHDVC4GERSTRXOWWGOIYL
                                            </td>
                                        </tr>


                                        <tr>
                                            <td>Step 5</td>
                                            <td>
                                                Calculate Exchange Rate
                                            </td>
                                            <td>
                                                POST /v2/merchant/calculate-exchange-rates
                                                <br />
                                                Output:
                                                sender_amount,
                                                receiver_amount,
                                                currrates,
                                                fees,
                                                fixed_side
                                                <br />
                                                All values must be reused without modification.
                                            </td>
                                        </tr>


                                        <tr>
                                            <td>Step 6</td>
                                            <td>
                                                Retrieve Available Payout Institutions
                                            </td>
                                            <td>
                                                POST /v2/merchant/get-payout-list
                                                <br />
                                                Output:
                                                locationId, locationName
                                            </td>
                                        </tr>


                                        <tr>
                                            <td>Step 7</td>
                                            <td>
                                                Retrieve Dynamic Recipient Form
                                            </td>
                                            <td>
                                                POST /v2/merchant/get-recipient-form
                                                <br />
                                                Dynamically generates beneficiary fields
                                                based on country and payout provider.
                                            </td>
                                        </tr>


                                        <tr>
                                            <td>Step 8</td>
                                            <td>
                                                Retrieve Branch Codes (if required)
                                            </td>
                                            <td>
                                                POST /v2/merchant/get-branch-codes
                                                <br />
                                                Required only when selected payout
                                                institution requires branch routing.
                                            </td>
                                        </tr>


                                        <tr>
                                            <td>Step 9</td>
                                            <td>
                                                Submit Payment
                                            </td>
                                            <td>
                                                POST /v2/merchant/make-payment
                                                <br />
                                                Inputs:
                                                recipient fields,
                                                exchange rate values,
                                                locationId,
                                                session_id
                                                <br />
                                                Output:
                                                Transaction ID
                                            </td>
                                        </tr>


                                        <tr>
                                            <td>Step 10</td>
                                            <td>
                                                Store Transaction Identifier
                                            </td>
                                            <td>
                                                Example:
                                                F5C8KKEWQR5EO
                                            </td>
                                        </tr>


                                        <tr>
                                            <td>Step 11</td>
                                            <td>
                                                Track Transaction Status
                                            </td>
                                            <td>
                                                POST /v2/merchant/get-transaction-detail
                                            </td>
                                        </tr>


                                        <tr>
                                            <td>Step 12</td>
                                            <td>
                                                Perform Reconciliation
                                            </td>
                                            <td>
                                                Match transaction records with internal
                                                settlement and reporting systems for audit
                                                and financial reconciliation.
                                            </td>
                                        </tr>


                                    </tbody>


                                </table>


                            </section>

                        </article>




                        <article class="docs-article">

                            <section class="docs-section">


                                <h2 class="section-heading">
                                    Key Flow Rules
                                </h2>


                                <table class="table table-bordered table-white">


                                    <thead>

                                        <tr>
                                            <th>Rule</th>
                                            <th>Description</th>
                                        </tr>

                                    </thead>


                                    <tbody>


                                        <tr>
                                            <td>
                                                Sequential Flow
                                            </td>
                                            <td>
                                                APIs must be called in the exact order
                                                defined above.
                                            </td>
                                        </tr>


                                        <tr>
                                            <td>
                                                Session Dependency
                                            </td>
                                            <td>
                                                <code>session_id</code> must remain
                                                unchanged throughout the transaction.
                                            </td>
                                        </tr>


                                        <tr>
                                            <td>
                                                Data Consistency
                                            </td>
                                            <td>
                                                Exchange rate values must not be modified.
                                            </td>
                                        </tr>


                                        <tr>
                                            <td>
                                                Dependency Enforcement
                                            </td>
                                            <td>
                                                Each API depends on the output of
                                                previous APIs.
                                            </td>
                                        </tr>


                                        <tr>
                                            <td>
                                                Transaction Integrity
                                            </td>
                                            <td>
                                                Invalid or skipped steps will cause
                                                transaction failure.
                                            </td>
                                        </tr>


                                    </tbody>


                                </table>


                            </section>


                        </article>




                        <article class="docs-article">


                            <section class="docs-section">


                                <h2 class="section-heading">
                                    Conclusion
                                </h2>


                                <p>
                                    The E-Pocket Merchant API provides a secure and
                                    scalable remittance integration platform that
                                    supports dynamic recipient validation, real-time
                                    exchange rate calculation, payout institution
                                    selection, payment processing, transaction tracking,
                                    and reconciliation.
                                </p>


                                <p>
                                    Partners should strictly follow the integration
                                    sequence outlined in this document and ensure that
                                    all authentication, validation, and business rules
                                    are implemented correctly to guarantee successful
                                    transaction processing.
                                </p>


                            </section>


                        </article>

                        <article class="docs-article" id="section-3">
                            <section class="docs-section row" id="item-3-1">
                                <div class="col-12">
                                    <nav aria-label="Page navigation example">
                                        <ul class="pagination justify-content-between">
                                        <li class="page-item">
                                            <Link
                                                class="page-link"
                                                to="/merchant-security"
                                                tabIndex="-1"
                                                aria-disabled="true"
                                            >
                                                <i class="bi bi-arrow-left"></i>&nbsp;
                                                Security Recommendations
                                            </Link>
                                        </li>

                                        <li class="page-item">
                                        </li>
                                        </ul>
                                    </nav>
                                </div>

                            </section>

                        </article>


                    </div>

                </div>

            </div>
        )
    }

}